export const CREATE_POST = "CREATE_POST";
export const GET_CREATE_POST_RESPONSE = "GET_CREATE_POST_RESPONSE";
export const GET_ALL_POSTS = "GET_ALL_POSTS";
export const GET_ALL_POST_RESPONSE = "GET_ALL_POST_RESPONSE";
export const DELETE_ADMIN_POST = "DELETE_ADMIN_POST";
export const DELETE_ADMIN_POST_RESPONSE = "DELETE_ADMIN_POST_RESPONSE";
